import MemberOrganisationCategoryView from "../../features/MetabaseDashboard/MemberOrganisationCategoryView"

const MemberOrganisationCategory = () => {
  return (
    <div><MemberOrganisationCategoryView /></div>
  )
}

export default MemberOrganisationCategory